/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to create a new claim folder
 * @export
 * @interface CreateClaimFolderRequest
 */
export interface CreateClaimFolderRequest {
    /**
     * Folder name
     * @type {string}
     * @memberof CreateClaimFolderRequest
     */
    name: string;
    /**
     * Optional hex color code for folder display (e.g., "#3B82F6")
     * @type {string}
     * @memberof CreateClaimFolderRequest
     */
    color?: string | null;
}

/**
 * Check if a given object implements the CreateClaimFolderRequest interface.
 */
export function instanceOfCreateClaimFolderRequest(value: object): value is CreateClaimFolderRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateClaimFolderRequestFromJSON(json: any): CreateClaimFolderRequest {
    return CreateClaimFolderRequestFromJSONTyped(json, false);
}

export function CreateClaimFolderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClaimFolderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'color': json['color'] == null ? undefined : json['color'],
    };
}

export function CreateClaimFolderRequestToJSON(json: any): CreateClaimFolderRequest {
    return CreateClaimFolderRequestToJSONTyped(json, false);
}

export function CreateClaimFolderRequestToJSONTyped(value?: CreateClaimFolderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'color': value['color'],
    };
}

